/**
 * 플랫폼 지원 열람 모드 (CR-019). 플랫폼 관리자가 세션을 시작하면 여기 저장되고,
 * 이후 모든 API 요청은 대상 테넌트 슬러그 + X-Support-Session 헤더로 나간다 (읽기 전용).
 */
const KEY = 'prism.support';
export interface SupportMode { sessionId: string; tenantId: string; tenantSlug: string; tenantName: string; reason: string; expiresAt: string }
export function supportMode(): SupportMode | null { try { const v = localStorage.getItem(KEY); return v ? (JSON.parse(v) as SupportMode) : null; } catch { return null; } }
export function enterSupport(m: SupportMode) { try { localStorage.setItem(KEY, JSON.stringify(m)); } catch { /* ignore */ } }
export function leaveSupport() { try { localStorage.removeItem(KEY); } catch { /* ignore */ } }
